import React from "react";
import { Icon } from "../../Icon";
import { FC } from "../../../types";

export const CalendarIcon: FC = () => {
  return <Icon name="calendar_today" size="medium" />;
};
